import Form from 'flarum/common/components/Form';
import app from 'flarum/common/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import username from 'flarum/common/helpers/username';
import Avatar from 'flarum/common/components/Avatar';
export default class RequestDataExportModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
  }
  className() {
    return 'RequestDataModal Modal--small';
  }
  title() {
    return app.translator.trans('flarum-gdpr.lib.request_data.title', {
      username: username(this.user)
    });
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "User"
    }, m(Avatar, {
      user: this.user
    })), m("p", {
      className: "helpText"
    }, app.translator.trans('flarum-gdpr.lib.request_data.text')), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      onclick: () => this.requestExport(),
      loading: this.loading,
      disabled: this.loading
    }, app.translator.trans('flarum-gdpr.lib.request_data.request_button')))));
  }
  requestExport() {
    this.loading = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/gdpr-exports',
      body: {
        data: {
          attributes: {
            userId: this.user.id()
          }
        }
      }
    }).then(this.hide.bind(this), this.loaded.bind(this));
  }
}
flarum.reg.add('flarum-gdpr', 'common/components/RequestDataExportModal', RequestDataExportModal);